// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_ganancias_ganancias_module_ts":"b481a200daf88ed0","node_modules_quill_dist_quill_js":"55016669f1a1f376"}[chunkId] + ".js";
};